import getApiUrl from "../helpers/getApiUrl";
import getEnvironment from "../helpers/getEnvironment";

const deleteNote = async (
  vrm: string | string[],
  saleCode: string,
  inventoryID: string | null,
  isToUseAuthZero: boolean = false,
  accessToken?: string
) => {
  const isLocalhost = !["preview", "production"].includes(getEnvironment());
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
  };

  if (isToUseAuthZero && accessToken) {
    headers.Authorization = `Bearer ${accessToken}`;
  } else if (!isToUseAuthZero && isLocalhost && process.env.token) {
    headers.Authorization = `Bearer ${process.env.token}`;
  }

  const noteURL = getApiUrl(
    `${process.env.apiFunctionUrl}/api/buyer/note/${vrm}/${saleCode}?inventoryID=${inventoryID}`,
    isToUseAuthZero
  );

  const res = await fetch(noteURL, {
    method: "DELETE",
    headers,
  });

  if (res.status === 200) {
    // try to deserialize and on failure return status code
    return res.json().catch(() => res);
  }

  return res;
};

export default deleteNote;
